/**
 * 페이지 이름의 단일 출처.
 *
 * 왼쪽 GNB의 라벨과 브라우저 탭 제목이 같은 값을 쓴다 — 한쪽만 고쳐 어긋나는 일이 없게.
 * 서비스명은 로고(파비콘)가 말해주므로 탭 제목에는 페이지 이름만 넣는다.
 *
 * 여기 없는 경로는 app/layout.tsx의 기본 제목("story37")이 그대로 쓰인다.
 */
export const PAGE_TITLES = {
  "/conflict-collector": "Conflict Collector",
  "/trope-collector": "Trope Collector",
  "/face-metrics": "얼굴 지표",
  "/face-adjust": "얼굴 조정 실험",
  "/plot/explorer": "Plots",
  "/plot/thesaurus": "Plot thesaurus",
  "/trope": "Tropes",
  "/material": "Materials",
  "/reel": "Reel",
  "/ltx": "LTX",
  "/project": "Project",
  "/shots": "Shots",
  "/workers": "Shot workers",
  "/comfylab": "ComfyLab",
  "/motion-index-review": "Motion index review",
  "/motion-index-relevance-review": "Motion index relevance",
  "/motion-index-stage-a-review": "Motion index stage A review",
  "/motion-index-stage-a-select": "Motion index stage A select",
  "/scene-review": "탄막 감수"
} as const;

export type PageTitlePath = keyof typeof PAGE_TITLES;

export function pageTitle(path: PageTitlePath) {
  return PAGE_TITLES[path];
}
